import React from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { commonStyles } from '../../styles/styles';
import Popup from '../Popup';
import RegistrationForm from '../Form/RegistrationForm';
import Logo from '../Logo';
import registerBg from '../../assets/registration_image.png';

const RegistrationPopup = ({ classes, handleLoginPopup }) => (
  <div>
     <RegistrationForm />
  </div>
  
);

RegistrationPopup.propTypes = {
  classes: PropTypes.instanceOf(Object),
  handleLoginPopup: PropTypes.func,
};
const styles = () => ({
  ...commonStyles,
});

export default compose(withStyles(styles))(RegistrationPopup);
